import { TFunction } from 'i18next'

type ValidationRule = {
  required: boolean
  textError: string
}

type ValidationConfig = Record<string, ValidationRule>
type FieldToTabMap = Record<string, number>

export const getCategoryValidationConfig = (
  localizationKeys: string[],
  t: TFunction,
): ValidationConfig => {
  const config: ValidationConfig = {}

  localizationKeys.forEach((locale) => {
    config[`localization.${locale}.name`] = {
      required: true,
      textError: t('requiredField'),
    }
  })

  return config
}

export const getCategoryFieldToTabMap = (
  localizationKeys: string[],
): FieldToTabMap => {
  const fieldToTabMap: FieldToTabMap = {}

  localizationKeys.forEach((locale, index) => {
    fieldToTabMap[`localization.${locale}.name`] = index + 1
  })

  return fieldToTabMap
}
